import { useCallback } from "react";
import { ColorPicker } from "../components/editor/ColorPicker";
import { SubmitPreviewImage } from "../components/editor/SubmitPreviewImage";
import { Btn } from "../components/UI/Btn";
import { useStrokeContext } from "../services/editor/editorContext";
import { useRouterContext } from "../services/router/routerContext";

export const ColorPage: React.FC = () => {

    const { clear, color, setColor } = useStrokeContext();
    const { showEditor, showComment } = useRouterContext();

    const backHandler = useCallback( () => {

        clear();
        setColor( undefined );
        showEditor();

    }, [ clear, setColor, showEditor ] );

    const nextHandler = useCallback( () => {

        if ( color ) {
            showComment();
        }

    }, [ showComment, color ] );


    return <>
    
        <div style={{ 
            gridArea: "main",
            width: "100%",
            display: "flex",
            justifyContent: "center",

        }}>
            <div>
                <SubmitPreviewImage />
            </div>
        </div>

        <div style={{ gridArea: "sub" }}>

            <ColorPicker />

        </div>

        <Btn 
            area="left"
            icon="left"
            square
            inverse
            onClick={backHandler}
        />

        {color && <Btn 
            area="right"
            icon="right"
            square
            onClick={nextHandler}
        /> }
    
    </>;


}